import { render, staticRenderFns } from "./UserSettingsProfile.vue?vue&type=template&id=3d4e96e7&"
import script from "./UserSettingsProfile.vue?vue&type=script&lang=js&"
export * from "./UserSettingsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports